import React, { Component } from "react";
import { MdKeyboardReturn, MdRepeat, MdAssignment, MdAssignmentTurnedIn } from 'react-icons/lib/md';
import MultiselectTwoSides from "react-multiselect-two-sides";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';

import { NavLink } from 'react-router-dom';

class ProcessoTramitacaoForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alternarTodos: false
    };
  }

  quandoMudarClassifcacao = (selecionados) => {
    console.log(selecionados);

    // const selecionados = [...target.options]
    //   .filter(s => s.selected)
    //   .map(s => parseInt(s.value, 10));
    this.props.quandoMudar({ target: { name: "processo_tiposAlegacao", value: selecionados } });
  }

  render() {
    const {
      processo,
      responsaveis,
      situacoes,
      alegacoes: alegacoesOriginal = [],
      tramitar,
      history,
      quandoMudar
    } = this.props;

    const {
      tiposAlegacao: tps = [],
      responsavel = {},
      situacao = {},
      id: processoId,
      decisao: { id: decisaoId } = {} } = processo;


    const selecionados = tps.map(({ id }) => id);
    const alegacoes = alegacoesOriginal.map(({ id, nome }) => ({ name: nome, value: id }));
    const totalSelecionados = selecionados.length;
    const totalDisponiveis = alegacoes.length - totalSelecionados;

    const situacaoAtual = this.props.de;

    return (
      <Form onSubmit={e => tramitar(e, history)}>
        <Card tag="fieldset">
          <CardHeader tag="legend">
            Tramitação
          </CardHeader>
          <CardBody>
            {
              situacao.fim &&
              <Row>
                <Col sm={7}>
                  <FormGroup>
                    <Label for="proceso_tiposAlegacao">Classificação</Label>
                    <Input plaintext>{tps.reduce((acu, { nome }) => `${acu}${nome}, `, "").replace(/,\s$/, "")}</Input>
                  </FormGroup>
                </Col>
              </Row>
            }
            {
              !situacao.fim &&
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="responsavel">Responsável</Label>
                    <Input type="select" name="processo_cpfResponsavel" value={responsavel.cpf} onChange={quandoMudar}>
                      <option key="" value="" />
                      {
                        responsaveis.map(({ cpf, nome }) => <option key={cpf} value={cpf}>{nome} </option>)
                      }
                    </Input>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="situacao">Situação</Label>
                    <Input type="select" name="processo_idSituacao" value={situacao.id} onChange={quandoMudar}>>
                      {
                        situacoes.map(({ id, descricao }) => <option key={id} value={id}>{descricao} </option>)
                      }
                    </Input>
                  </FormGroup>
                </Col>
                <Col sm={12}>
                  <FormGroup>
                    <Label for="proceso_tiposAlegacao">Classificação</Label>
                    <MultiselectTwoSides
                      options={alegacoes}
                      value={selecionados}
                      className="sr-multiselect"
                      onChange={this.quandoMudarClassifcacao}
                      availableHeader="Disponíveis"
                      availableFooter={`Disponíveis: ${totalDisponiveis}`}
                      selectedHeader="Selecionadas"
                      selectedFooter={`Selecionadas: ${totalSelecionados}`}
                      labelKey="name"
                      placeholder="Filtro…"
                      showControls
                      searchable
                    />
                  </FormGroup>
                </Col>
              </Row>
            }
            <Row>
              <Col sm={12}>
                <ButtonGroup size="sm" className="float-right">
                  <Button type="reset" color="secondary" onClick={history.goBack}><MdKeyboardReturn />Voltar</Button>
                  {
                    situacaoAtual === "Aguardando Parecer" && <Button color="secondary" tag={NavLink} to={`/processo/${processoId}/parecer`}><MdAssignment />{' '}Emitir Parecer</Button>
                  }
                  {
                    situacaoAtual === "Aguardando Decisão" && <Button color="secondary" tag={NavLink} to={`/processo/${processoId}/decisao`}><MdAssignmentTurnedIn />{' '}Registrar Decisão</Button>
                  }
                  {
                    !situacao.fim && <Button type="submit" color="warning"><MdRepeat />{' '}Salvar</Button>
                  }
                </ButtonGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Form >
    );
  };
}

export default ProcessoTramitacaoForm;



// WEBPACK FOOTER //
// ./src/componentes/ProcessoTramitacaoForm.js